import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-success-follow-up',
  templateUrl: './success-follow-up.component.html',
})
export class SuccessFollowUpComponent implements OnInit {
  SUCCESS_MESSAGE = "Follow up submitted successfully";

  constructor(
    private modalController: ModalController,
    private route: Router
  ) {}

  ngOnInit() {}

  dismiss() {
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  goHome() {
    this.dismiss();
    this.route.navigateByUrl('/home');
  }
}
